import React from 'react';
import { Button } from 'reactstrap';

export const ConversationMultipleDownload = ({
  handleMultiDownload,
  handleDownloadConversationsZip,
  isMultiDownload,
  selectedRows,
  loadingZip
}) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        marginTop: '.5rem'
      }}
    >
      <label style={{ fontWeight: '400' }} className="form-control-label m-0">
        <input
          onChange={handleMultiDownload}
          defaultValue={false}
          type="checkbox"
        />{' '}
        Download de Múltiplas Conversas
      </label>

      {isMultiDownload && selectedRows.length ? (
        <Button
          size="sm"
          color="primary"
          title="Realizar múltiplos download de conversas"
          onClick={() => handleDownloadConversationsZip(selectedRows)}
          disabled={!selectedRows.length || loadingZip}
        >
          {loadingZip ? (
            <>
              <i className="fas fa-spinner fa-spin"></i>
            </>
          ) : (
            <>
              <i className="fas fa-cloud-download-alt"></i>
            </>
          )}
        </Button>
      ) : null}
    </div>
  );
};
